import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { ChecklistConfiguration } from './../config/checklist_configuration';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-checklist').factory(
  'loadChecklistItemsCommand',
  (
    $http: ng.IHttpService,
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngChecklistConfiguration: ChecklistConfiguration,
    ngChecklistItemsDatasource: IChecklistItemsDatasource
  ): ICommand => {
    return defineCommand('loadChecklistItemsCommand', (deferred: ng.IDeferred<IQuery[]>) => {
      $http({
        method: 'GET',
        url: `${ngChecklistConfiguration.capability.checklistUrl}event-chain/`
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>) => {
          ngChecklistItemsDatasource.clear();
          ngChecklistItemsDatasource.configure({ mergeStrategy: 'assign' });
          ngChecklistItemsDatasource.write(response.data.results);
          ngChecklistItemsDatasource.configure({ mergeStrategy: 'merge' });

          deferred.resolve(QueryMediator.runQueries(ngChecklistItemsDatasource));
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/load_checklist_items_command.ts